import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import { useElementIDSync } from "../ElementSync/index.js";

/**
 * Renders the label container for the custom Select.
 *
 * This is a simple wrapper around a span but it's ID is synced with the `MenuButton` component, which
 * makes a reference to the label via `aria-labelledby` to support screen readers
 */
const Label = _ref => {
  let {
    as: ComponentToRender,
    id: idProp,
    ...props
  } = _ref;
  const id = useElementIDSync('Label', idProp);
  return /*#__PURE__*/React.createElement(ComponentToRender, _extends({
    id: id
  }, props));
};
process.env.NODE_ENV !== "production" ? Label.propTypes = {
  /**
   * Underlying element to render
   */
  as: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Override Label id
   */
  id: PropTypes.string
} : void 0;
Label.defaultProps = {
  as: 'span'
};
export default Label;